import React from "react"
import { Flex } from "@rebass/grid/emotion"

const Row = props => <Flex {...props} mx={-3} flexWrap="wrap" />

export default Row
